import type { RefObject } from "react";
import { useEffect, useState } from "react";
import { useOutsideClick } from "./useOutsideClick";
import { useLgBreakpoint } from "./useBreakpoint";

export const summaryRowTestId = "summary-row";
export const rowHeaderTextTestId = "row-header-text";

type Config = {
    tooltipRef: RefObject<HTMLElement | null>;
};

export const useTooltip = ({ tooltipRef }: Config) => {
    const lg = useLgBreakpoint();
    const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

    useOutsideClick({
        ref: tooltipRef,
        enabled: isTooltipOpen,
        handler: (event) => {
            // If user clicks outside the Tooltip, it closes, if the click is on it, nothing happens, will be handled by the tooltip itself
            if (event.target !== tooltipRef.current) setIsTooltipOpen(false);
        },
    });

    // Close tooltip on scroll when on desktop
    useEffect(() => {
        if (!lg || !isTooltipOpen) return;

        const handleScroll = () => {
            setIsTooltipOpen(false);
        };

        document.addEventListener("scroll", handleScroll);

        return () => {
            document.removeEventListener("scroll", handleScroll);
        };
    }, [lg, isTooltipOpen]);

    return {
        isTooltipOpen,
        setIsTooltipOpen,
    };
};
